var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-section-loader"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.showLoading)?_c('div',{staticClass:"c-section-loader__loader"},[_c('h2',[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }